import * as Sentry from "@sentry/browser";
import { Component, type ErrorInfo, type ReactNode } from "react";
import StandaloneHeader from "./shared/layout/header/StandaloneHeader";
import { ErrorScreen } from "./shared/screens/ErrorScreen";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ThemedErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log({ error, info });
    Sentry.withScope((scope) => {
      scope.setExtras({ info: info });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <StandaloneHeader />
          <ErrorScreen message="Det ser ut som noe gikk galt!" />
        </>
      );
    }

    return this.props.children;
  }
}
